import axios from "axios";

const reported = new Set();

// 로그인 요청 본문(axios 가 JSON 문자열로 바꾼 것)의 아이디
function loginUsername(data) {
  try {
    const username = (typeof data === "string" ? JSON.parse(data) : data)?.username;
    return typeof username === "string" ? username.slice(0, 100) : undefined;
  } catch (e) {
    return undefined;
  }
}

/**
 * 해외 차단 안내를 띄울 때 inapi 에 알림 — 어느 화면에서 무엇을 하다 막혔는지(운영팀 보안 이력·Slack 알림).
 * inapi 가 IP 를 다시 판정해 정말 막히는 접속만 받음. 실패해도 차단 안내(호출부)는 그대로 감.
 * trigger: PAGE_OPEN(로그인 화면 geo-check) · LOGIN(로그인 시도) · REQUEST(로그인 뒤 요청)
 * ponytail: 같은 화면·같은 일은 한 번만(화면을 열 때 여러 요청이 한꺼번에 막혀도 첫 요청 하나). 요청마다 남길 일이 생기면 키에 경로를 넣음
 */
export function reportGeoBlock(trigger, request) {
  try {
    const page = (location.pathname + location.hash).slice(0, 300);
    const key = `${trigger} ${page}`;
    if (reported.has(key)) return;
    reported.add(key);
    const url = request?.url ? new URL(request.url, request.baseURL || location.origin) : undefined;
    const authorization = request?.headers?.Authorization;
    axios
      .post(
        `${process.env.VUE_APP_SERVERURL}/auth/geo-blocked-report`,
        {
          app: "admin-certilife",
          page,
          trigger,
          ...(url && { server: url.host, method: request.method?.toUpperCase(), path: url.pathname.slice(0, 300) }),
          ...(trigger === "LOGIN" && { username: loginUsername(request?.data) }),
        },
        { timeout: 3000, ...(authorization ? { headers: { Authorization: authorization } } : {}) }
      )
      .catch(() => undefined);
  } catch (e) {
    // 무시
  }
}
